module.exports = __webpack_public_path__ + "static/media/hp-section-03.e3111970.jpg";